/**
 * Which app targets a component (or one of its properties, or an action) is supported on. Read by the designer
 * palette, drop/paste guards, the property panel, the MCP platform validator and the CoreApi publish validation.
 *
 * Values are persisted as numbers in the component registry (`Backend/CoreApi/Metadatas`) and mirrored by
 * `Kuika.Designtime.Model.Enums.EAppSupportType` — add members here and there in the same change, never renumber.
 */
export enum EAppSupportType {
  /** Every target: web, native Android/iOS and React Native. */
  All = 0,
  /** Web only. Hidden on a Mobile project's mobile screens; allowed on its WebScreens. */
  Web = 1,
  /** Mobile only (native and React Native). Hidden on a Desktop project. */
  Mobile = 2,
  /**
   * Web, and mobile ONLY when that platform is generated with React Native. The Kotlin/Swift generators have no
   * emitter for it: a native build would drop it silently, so the publish validation refuses a Native platform
   * that carries one (KV1263) while the palette still offers it (with a React Native badge) on mobile screens.
   */
  WebAndReactNative = 3
}
